"use strict";

angular.module('app.modals.sceneSelectDataSource', [])

    .controller('sceneSelectDataSourceModalCtrl', ['$scope','close','f_User','ENUM','__Device','__Datapoint','__DatapointConfig','FilterDatapoint','$filter','Devices',
        function ($scope,close,f_User,ENUM,__Device,__Datapoint,__DatapointConfig,FilterDatapoint,$filter,Devices ) {

            $scope.init = function(){
                // Todo: resolve ENums via new Factory. (Merged later)
                $scope.$UI = {};
                $scope.DeviceTypes ={};
                $scope.Devices = Devices;
                $scope.DeviceTypes = ENUM.getDeviceTypesByFilter(4);
            }
            $scope.getDeviceType = function(DeviceType)
            {

                var l = $filter('filter')($scope.DeviceTypes, {'$pk': DeviceType});
                return l.length > 0 ? l[0] : {};
            }
            $scope.selectDeviceType = function(DeviceType){
                $scope.SelectedDeviceType = DeviceType.$pk;
                // Get Devices By Filter

                $scope.filter = {
                    MenuEntry: {
                        emptyRooms: false,
                        emptyRoomsButton: true,
                        selectable: false
                    },
                    Device: {
                        selectable: 'single',
                        show: [parseInt($scope.SelectedDeviceType)]
                    }
                };
                $scope.$broadcast('filter_update');
            }

            $scope.selectDevice = function(d){
                $scope.SelectedDevice = d;
                // Get Configs for Device
                var filter = { DeviceId : d.DeviceId, Filter: 3};

                $scope.Configs = __DatapointConfig.$ByFilterAndDeviceId(filter).$finally(function(){
                    // O.k. we should filter the Datapoints depending on FilterDatapoint
                    if(!FilterDatapoint) {
                        FilterDatapoint = {};
                    }

                        $scope.Configs = $filter('filter')($scope.Configs, function (item) {
                            return $scope.DatapointTypeCompareFilter(FilterDatapoint, item)
                        });


                });

            };

            $scope.toggle = function(){
                if($scope.$UI.showAdditional)
                {
                    $scope.$UI.showAdditional  = false;
                }else{
                    $scope.$UI.showAdditional = true;
                }
            }

            /**
             * Logic:
             * Int (0)      -> Bool,int,float
             * Float (1)    -> Bool,int,float
             * Bool (2)     -> Bool,int,float
             * String (3)   -> String
             * Datetime (4) -> Datetime
             * 
             * @param {Datapoint} dp1 A source dp
             * @param {Datapoint} dp2 A dependent dp.
             * @returns true if dp2 is selectable, false otherwise
             */
            $scope.DatapointTypeCompareFilter = function (dp1, dp2) {
                if (dp1.DatapointConfig.DatapointType === 0 ||
                    dp1.DatapointConfig.DatapointType === 1 ||
                    dp1.DatapointConfig.DatapointType === 2) {
                    if (dp2.DatapointType === 0 ||
                        dp2.DatapointType === 1 ||
                        dp2.DatapointType === 2) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else if (dp1.DatapointConfig.DatapointType === 3 &&
                         dp2.DatapointType === 3) {
                    return true;
                }
                else if (dp1.DatapointConfig.DatapointType === 4 &&
                         dp2.DatapointType === 4) {
                    return true;
                }
                else {
                    return false;
                }
            };
            $scope.setFilter = function (selects) {
                $scope.selectDevice(selects.Device[0]);

            }
            $scope.generateDataSource = function(Config){

                var Value = {
                    $type : Config._type.replace('DatapointConfig','DatapointValue'),
                    DeviceId : $scope.SelectedDevice.DeviceId,
                    DatapointConfigId : Config.DatapointConfigId
                };
                var DataSource = {
                    _type : "BMS.Shared.SceneData.Sources.SceneDataSourceRawDatapoint, BMS.Shared",
                    DatapointValue: Value,

                    $UI:{
                        $Device :$scope.SelectedDevice,
                        $Datapoint : __Datapoint.$buildRaw({
                            DatapointConfig : Config,
                            DatapointValue : Value
                        }),
                    }

                };
                $scope.DataSource = DataSource;
            }
            $scope.hasDatapoints = function(list,viz)
            {
                if(!list) return;
                if(viz)
                {
                    return list.length > 0;
                }else{
                    return $filter('filter')(list,{'IsDeviceVisualizationDatapoint':viz}).length > 0;
                }

            }
            $scope.close = function( a )
            {

                close( a );
            }
            $scope.init();

        }
    ])

    .factory('sceneSelectDataSourceModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (FilterDatapoint,Devices) {
            return ModalService.showModal({
                templateUrl: "views/modals/sceneSelectDataSource.html",
                controller: 'sceneSelectDataSourceModalCtrl',
                inputs : {
                    FilterDatapoint:FilterDatapoint,
                    Devices : Devices
                }
            });
        }
    }]);